import { markRaw } from 'vue'
import SignIn from '../layout/auth/components/SignIn.vue'
import { createStore } from 'vuex'
import SharedService from '../services/shared'
import { showToast as toast } from '@/helpers/UseToasts'
import Events from '../layout/authenticated/events.vue'

export const dataShared = createStore({
  state: () => {
    return {
      appLogo: null,
      dataUserLogged: null,

      // logo do app e download
      logo: null,
      download: {
        image: null,
        desc: 'Acesse a Number One a qualquer momento, em qualquer lugar, no seu dispositivo favorito.',
      },

      // https
      blockButtonsForHttpStatus29: false,
      cIdByCookie: null,

      // profile
      profile: {
        p_password: null,
      },

      // login
      bannerLogin: null,
      activeComponentLogin: SignIn,
      cLogin: {
        signIn: {
          email: null,
          password: null
        },
        signUp: {
          name: null,
          email: null,
          password: null
        }
      },

      componentActive: Events,
      menuActive: null,
      eventLiveId: null,
      eventLiveActived: null,
      loading: false,

      // theme
      blackTheme: false,

      // customer
      customer: [],
      customerId: [],
      isFighter: false,

      // noticias
      notices: [],
      noticeActiveById: null,

      // eventos
      events: [],
      nextEvents: [],
      eventPurchase: null,
      mainEvent: null,

      // lives
      lives: [],

      // profile
      
      // redirect
      fighter_url_redirect: null
    }
  },
  getters: {
    getLogo: (state) => state.logo,
    getDownloadConf: (state) => state.download,
    getAppLogo: (state) => state.appLogo = require('@/assets/logo/logo-rs.png'),
    getActiveComponent: (state) => state.componentActive,
    getTheme: (state) => state.blackTheme,
    getMenuActive: (state) => state.menuActive,
    getEventLiveId: (state) => state.eventLiveId,
    getEventLiveActivated: (state) => state.eventLiveActived,
    getNotices: (state) => state.notices,
    getEvents: (state) => state.events,
    getLives: (state) => state.lives,
    getNextEvents: (state) => state.nextEvents,
    seeNoticeActivated: (state) => state.noticeActiveById,
    eventPurchase: (state) => state.eventPurchase,
    getMainEvent: (state) => state.mainEvent,
    getCustomerData: (state) => state.customer,
    getCustomerId: (state) => state.customerId,
    getIsFighter: (state) => state.isFighter,
    getLoading: (state) => state.loading,
    bannerLogin: (state) => state.bannerLogin,
    getActiveComponentLogin: (state) => state.activeComponentLogin,
    buttonsBlockedForHttp29: (state) => state.blockButtonsForHttpStatus29,
    getCIdByCookie: (state) => state.cIdByCookie,
    getDataByUserLogged: (state) => state.dataUserLogged,
    getRedirectFighterCoupon: (s) => s.fighter_url_redirect,
  },
  mutations: {
    SET_COMPONENT_ACTIVE (state, value) {
      state.componentActive = value

      console.log(
        value.__name,
        value,
        state.componentActive
      );
      
      if (state.componentActive.__name == 'events') { 
        state.menuActive = 'eventos' 
      }

      if (
        state.componentActive.__name == 'noticias' || 
        state.componentActive.__name == 'theNotice'
      ) { 
        state.menuActive = 'noticias' 
      }

      if (state.componentActive.__name == 'lives') { 
        state.menuActive = 'lives' 
      }

      if (state.componentActive.__name == 'plans') { 
        state.menuActive = 'ppv' 
      }

      if (state.componentActive.__name == 'profile') { 
        state.menuActive = 'perfil' 
      }
    },
    SET_THEME (state, value) {
      state.blackTheme = value
    },
    SET_MAIN_EVENT (state, value) {
      state.mainEvent = value
    },
    SET_LIVE_ACTIVE (state, payload) {
      state.eventLiveId = payload.id
      state.eventLiveActived = payload
    },
    SET_COLLECTION_NOTICE (state, payload) {
      state.notices = []
      state.notices = {
        latest: payload.latest || [],
        recommended: payload.recommended || [],
        hot_now: payload.hot_now || [],
        older: payload.older || []
      }
    },
    SET_EVENT_COLLECTION (state, payload) {
      state.events = []
      state.events = payload
    },
    SET_LIVES_COLLECTION (state, payload) {
      state.lives = []
      state.lives = payload
    },
    SET_NEXT_EVENTS (state, payload) {
      state.nextEvents = []
      state.nextEvents = payload
    },
    SET_NOTICE_ACTIVATED (state, id) {
      let found = null

      for (const category of Object.values(state.notices)) {
        const notice = category.find(n => n.id === id)
        if (notice) {
          found = notice
          break
        }
      }

      if (found) {
        state.noticeActiveById = found
      }
    },
    SET_EVENT_TO_PURCHASE (state, id) {
      const event = state.events.find(n => n.id === id)

      if (event) {
        state.eventPurchase = event
      }
    },
    SET_CUSTOMER_DATA (state, payload) {
      state.customer = payload
    },
    SET_CUSTOMER_ID (state, payload) {
      state.customerId = payload
    },
    SET_IS_FIGHTER (state, payload) {
      state.isFighter = payload
    },
    LOADING (state, payload) {
      state.loading = payload
    },
    SET_BANNER_LOGIN (state, payload) {
      state.bannerLogin = payload
    },
    SET_COMPONENT_ACTIVE_LOGIN (state, value) {
      state.activeComponentLogin = value
    },
    SET_TIMER_FOR_HTTP_29 (state) {
      state.blockButtonsForHttpStatus29 = true

      setInterval(() => {
        state.blockButtonsForHttpStatus29 = false
      }, 60000) // 1 minuto
    },
    GET_CUSTOMER_ID_BY_COOKIE (state, id) {
      state.cIdByCookie = id
    },
    SET_USER(state, payload) {
      state.dataUserLogged = payload
    },
    SET_DOWNLOAD_CONF(state, payload) {
      state.download.desc = payload.download_descript
      state.download.image = payload.download_banner
    },
    SET_LOGO_APP(state, payload) {
      if(payload !== null)
        state.logo = process.env.VUE_APP_IMAGE_SERVE + 'storage/' + payload
    },
    SET_FIGHTER_URL(state, payload) {
      if(payload !== null)
        state.fighter_url_redirect = payload
    },
  },
  actions: {
    setTheme ({ commit }, value) {
      commit('SET_THEME', value)
    },
    setLiveActive ({ commit }, value) {
      commit('SET_LIVE_ACTIVE', value)
    },
    setAllNotices ({ commit }, payload) {
      commit('SET_COLLECTION_NOTICE', payload)
    },
    setAllEvents ({ commit }, payload) {
      commit('SET_EVENT_COLLECTION', payload)
    },
    setAllLives ({ commit }, payload) {
      commit('SET_LIVES_COLLECTION', payload)
    },
    setNextEvents ({ commit }, payload) {
      commit('SET_NEXT_EVENTS', payload)
    },
    setNoticeActive ({ commit }, payload) {
      commit('SET_NOTICE_ACTIVATED', payload)
    },
    setEventToPurchase ({ commit }, payload) {
      commit('SET_EVENT_TO_PURCHASE', payload)
    },
    setMainEvent ({ commit }, payload) {
      commit('SET_MAIN_EVENT', payload)
    },
    setCustomer ({ commit }, payload) {
      commit('SET_CUSTOMER_DATA', payload)
    },
    setCustomerId ({ commit }, payload) {
      commit('SET_CUSTOMER_ID', payload)
    },
    setIsFighter ({ commit }, payload) {
      commit('SET_IS_FIGHTER', payload)
    },
    activeLoading ({ commit }) {
      commit('LOADING', true)
    },
    desactiveLoading ({ commit }) {
      commit('LOADING', false)
    },
    // setLogo ({ commit }, value) {
    //   commit('SET_LOGO', value)
    // },
    setDownloadConf ({ commit }, value) {
      commit('SET_DOWNLOAD_CONF', value)
    },
    setBannerLogin ({ commit }, value) {
      commit('SET_BANNER_LOGIN', value)
    },
    setComponentActive ({ commit }, value) {
      commit('SET_COMPONENT_ACTIVE', value)
    },
    setComponentActiveLogin ({ commit }, value) {
      commit('SET_COMPONENT_ACTIVE_LOGIN', value)
    },
    getCookieByName ({ commit }, cookieName) {
      const id = Cookies.get(cookieName) || null
      commit('SET_CUSTOMER_ID_BY_COOKIE', id)
      return id
    },
    async getLogo ({ commit }) {
      await SharedService.getLogo()
        .then((res) => {
          commit('SET_LOGO_APP', res.data?.logo_app)
          localStorage.setItem('app_logo_c', res.data?.logo_app)
        })
        .catch((err) => {
          console.log(err)
        })
    },
    async fetchLoggedUser({ commit }) {
      await SharedService.me()
      .then(res => {
        if (res.data && res.data.id) {
          commit('SET_USER', res.data)
        }
      }).catch(err => {
        if (err?.response?.data?.error && err.response.data.status === 429) {
          toast(
            'Aviso',
            'Multiplas tentataivas',
            'error'
          )
          dataShared.dispatch('set29')
        }

        if (err?.response?.data?.error && err.response?.data?.status === 401) {
          toast(
            'Aviso',
            err.response.data.message,
            'error'
          )
        }
      })
    },
    setRedirectFighterCoupon({ commit }, val) {
      commit('SET_FIGHTER_URL', val);
    },
    // http
    set29 ({ commit }) {
      commit('SET_TIMER_FOR_HTTP_29')
    }
  }
})
